import { useCallback } from 'react';
import { InteractionManager } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { useActor } from '@xstate/react';

import { useGlobalAppState } from '@order/GlobalAppState';

import type { ReorderStep } from '../../machines/Reorder.machine';
import { logger } from '../utils';

// Dismissing the Reorder modals through native navigation should cancel the reorder flow.
export const useDismissReorder = (step: ReorderStep) => {
  const { reorderMachineRef } = useGlobalAppState();
  const [, sendReorderEvent] = useActor(reorderMachineRef);

  useFocusEffect(
    useCallback(() => {
      return () => {
        // This will trigger the event to cancel the reorder flow after the modal has been dismissed.
        void InteractionManager.runAfterInteractions(() => {
          logger.info(`Dismissing Reorder from ${step}`);
          sendReorderEvent({ type: 'CANCEL_REORDER', step });
        });
      };
    }, [step, sendReorderEvent]),
  );
};
